module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page003"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_1"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_006"
    }
  }, [_vm._v("French Cuisine"), _c('span', {
    staticClass: "page003_2a"
  }, [_vm._v("   page 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_011"
    }
  }, [_vm._v("Recipes"), _c('span', {
    staticClass: "page003_3a"
  }, [_vm._v("   page 11")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_013"
    }
  }, [_vm._v("BASICS")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_013"
    }
  }, [_vm._v("page 13")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STARTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 33")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAIN COURSES")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 57")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DESSERTS")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 11")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page003_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index "), _c('span', {
    staticClass: "page003_12a"
  }, [_vm._v("page 166")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd807f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_003.vue
// module id = 63
// module chunks = 0